import { Component, ErrorHandler, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { Message } from 'src/app/open-age/send-it/models';
import { MessageService } from 'src/app/open-age/send-it/services';
import { PagerModel } from '~/app/open-age/core/structures';
import { RoleService } from '../../core/services';

export class InboxBaseComponent extends PagerModel<Message> implements OnInit, OnChanges {

  @Input()
  view: 'table' | 'list' | 'grid' = 'table';

  @Input()
  unread = false;

  @Input()
  sort = 'date';

  selectedSubject: string;

  constructor(
    private service: MessageService,
    private errorHandler: ErrorHandler
  ) {
    super({
      api: service,
      filters: ['to', 'subject', 'status'],
      pageOptions: { limit: 20 },
      errorHandler
    });
  }

  ngOnInit() {
    this.refresh();
  }

  ngOnChanges() {
    this.refresh();
  }

  refresh() {
    this.filters.properties['to'].value = 'my';

    if (this.selectedSubject) {
      this.filters.properties['subject'].value = this.selectedSubject;
    }
    this.fetch();
  }
}
